import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n/config';
import './index.css';

// Sentry初期化
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // プライバシー保護：テキストをマスク
      maskAllText: true,
      // メディアをブロック
      blockAllMedia: true,
    }),
  ],
  // エラーサンプリング（100%）
  sampleRate: 1.0,
  // パフォーマンストレースのサンプリング
  tracesSampleRate: 0.2,
  // セッションリプレイのサンプリング
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// MSWを開発環境でのみ有効化
async function enableMocking() {
  // mswを有効にしたいときはコメントアウト
  return;

  // mswを有効にしたい時はアンコメント

  // if (typeof window !== 'undefined') {
  //   console.log('window is defined');
  //   const { worker } = await import('./mocks/browser');

  //   return worker.start({
  //     onUnhandledRequest: 'bypass',
  //   });
  // } else {
  //   console.log('window is undefined');
  //   return;
  // }
}

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
